import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const RequestConfig = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://devapi.vandawallet.com/",
});

RequestConfig.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = "token " + token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

RequestConfig.interceptors.response.use(
  (response) => {
    // If the response is successful, just return the response
    return response;
  },
  (error) => {
    // Check if the error response status is 401
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // Set a cookie (example: 'redirected=true')
      Cookies.remove("token");
      toast.error("توکن نامعتبراست");
      // Redirect to the home page
      window.location.href = "/";
    } else {
      // For other errors, return the error as a rejected promise
      return Promise.reject(error);
    }
  }
);
// RequestConfig.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     (error) => {
//         if (error.response && error.response.status === 401) {
//             console.error("Unauthorized access - perhaps redirect to login?");
//             Cookies.remove('token');
//             const navigate = useNavigate();
//             navigate('/');

//         }
//         return Promise.reject(error);
//     }
// );

// RequestConfig.interceptors.response.use(
//   (response) => {
//     // If the response is successful, just return the response
//     return response;
//   },
//   (error) => {
//     // Check if the error response status is 401
//     if (error.response && error.response.status === 401) {
//       // Set a cookie (example: 'redirected=true')
//       Cookies.remove("token");

//       // Redirect to the home page
//       window.location.href = "/";
//     } else {
//       // For other errors, return the error as a rejected promise
//       return Promise.reject(error);
//     }
//   }
// );

export default RequestConfig;
